import { render, staticRenderFns } from "./TrendingDebates.vue?vue&type=template&id=7925f904&scoped=true&"
import script from "./TrendingDebates.vue?vue&type=script&lang=js&"
export * from "./TrendingDebates.vue?vue&type=script&lang=js&"
import style0 from "./TrendingDebates.vue?vue&type=style&index=0&id=7925f904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7925f904",
  null
  
)

export default component.exports